import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReusableTable from '../../components/ReusableTable';
import ComentarioButton from '../../components/ComentarioButton';
import PrioridadButton from '../../components/PrioridadButton';
import CambiarAreaButton from '../../components/CambiarAreaButton';
import CambiarCategoriaButton from '../../components/CambiarCategoriaButton';
import EvidenciaButton from '../../components/EvidenciaButton';
import Modal from '../../components/Modal';
import SoporteLayout from '../../layouts/SoporteLayout';
import { getUsuariosPorJefe, asignarResponsableTarea } from '../../services/Admin/tareasSinResponsableService';
import { updateEstadoTarea } from '../../services/tareasService';
import { getTareasPorEstado, getTareasPorFiltroFecha, getTareasPorEstadosEspecificos } from '../../services/Admin/tareasAdminService';
import { getDetalleByParametroId } from '../../services/Admin/detalleParametroService';
import { getAreas } from '../../services/Admin/areaService';
import { jwtDecode } from 'jwt-decode';
import withAuth from '../../routes/withAuth';
import { formatearBogota } from '../../utils/fecha';

const getUserArea = () => {
    const token = localStorage.getItem('authToken');
    if (!token) return null;
    try {
      const decodedToken = jwtDecode(token);
      // Asumiendo que el areaId está en el token. Ajusta si el campo se llama diferente.
      return decodedToken.areaId; 
    } catch (error) {
      console.error("Error decodificando el token:", error);
      return null;
    }
};

const VerTareasAreaPage = () => {
  const location = useLocation();
  const isSoporteRoute = location.pathname.includes('/soporte/');
  const [tareas, setTareas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [mostrandoTareasCompletas, setMostrandoTareasCompletas] = useState(false);
  const [mostrandoTareasPorFecha, setMostrandoTareasPorFecha] = useState(false);
  const [mostrandoTareasEstadosEspecificos, setMostrandoTareasEstadosEspecificos] = useState(false);
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [usuarios, setUsuarios] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedTarea, setSelectedTarea] = useState(null);
  const [selectedUsuario, setSelectedUsuario] = useState('');
  const [modalLoading, setModalLoading] = useState(false);
  const [modalError, setModalError] = useState('');
  const [modalSuccess, setModalSuccess] = useState('');
  const [showEstadoModal, setShowEstadoModal] = useState(false);
  const [estadoLoading, setEstadoLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [selectedEstado, setSelectedEstado] = useState('');
  const [tareaEstado, setTareaEstado] = useState(null);
  const [estadoError, setEstadoError] = useState('');
  const [nombreArea, setNombreArea] = useState('');
  const [showVerModal, setShowVerModal] = useState(false);
  const [detalleTarea, setDetalleTarea] = useState(null);
  const userArea = getUserArea();

  useEffect(() => {
    const fetchTareas = async () => {
      const response = await getTareasPorEstado(1);
      if (response.success) {
        console.log('Tareas activas recibidas:', response.data);
        const tareasOrdenadas = response.data.slice().sort((a, b) => b.idTarea - a.idTarea);
        setTareas(tareasOrdenadas);
      } else {
        setError(response.message);
      }
      setLoading(false);
    };

    const fetchNombreArea = async () => {
      if (userArea) {
        try {
          const areasResponse = await getAreas();
          if (Array.isArray(areasResponse)) {
            const area = areasResponse.find(a => (a.id_area || a.id || a.areaId) === userArea);
            if (area) {
              setNombreArea(area.nombre_area || area.nombre || area.areaNombre || 'Área Desconocida');
            } else {
              setNombreArea('Área Desconocida');
            }
          } else if (areasResponse && Array.isArray(areasResponse.data)) {
            const area = areasResponse.data.find(a => (a.id_area || a.id || a.areaId) === userArea);
            if (area) {
              setNombreArea(area.nombre_area || area.nombre || area.areaNombre || 'Área Desconocida');
            } else {
              setNombreArea('Área Desconocida');
            }
          } else {
            setNombreArea('Área Desconocida');
          }
        } catch (error) {
          console.error('Error al cargar el nombre del área:', error);
          setNombreArea('Área Desconocida');
        }
      }
    };

    fetchTareas();
    fetchNombreArea();
    
    // Cargar usuarios para asignar responsable
    getUsuariosPorJefe().then(res => {
      if (res.success && res.data) {
        // Si el backend retorna { admin: {...}, usuarios: [...] }
        if (Array.isArray(res.data.usuarios)) {
          const todos = [res.data.admin, ...res.data.usuarios];
          setUsuarios(todos);
        } else if (Array.isArray(res.data)) {
          setUsuarios(res.data);
        } else {
          setUsuarios([]);
        }
      }
    });
  }, [userArea]);

  const cargarTareasCompletas = async () => {
    setLoading(true);
    setError(null);
    const response = await getTareasPorEstado(0);
    if (response.success) {
      console.log('Tareas completas recibidas:', response.data);
      const tareasOrdenadas = response.data.slice().sort((a, b) => b.idTarea - a.idTarea);
      setTareas(tareasOrdenadas);
      setMostrandoTareasCompletas(true);
      setMostrandoTareasPorFecha(false);
      setMostrandoTareasEstadosEspecificos(false);
    } else {
      setError(response.message);
    }
    setLoading(false);
  };

  const cargarTareasActivas = async () => {
    setLoading(true);
    setError(null);
    const response = await getTareasPorEstado(1);
    if (response.success) {
      console.log('Tareas activas recibidas:', response.data);
      const tareasOrdenadas = response.data.slice().sort((a, b) => b.idTarea - a.idTarea);
      setTareas(tareasOrdenadas);
      setMostrandoTareasCompletas(false);
      setMostrandoTareasPorFecha(false);
      setMostrandoTareasEstadosEspecificos(false);
    } else {
      setError(response.message);
    }
    setLoading(false);
  };

  const cargarTareasEstadosEspecificos = async () => {
    setLoading(true);
    setError(null);
    const response = await getTareasPorEstadosEspecificos();
    if (response.success) {
      console.log('Tareas con estados específicos recibidas:', response.data);
      const tareasOrdenadas = response.data.slice().sort((a, b) => b.idTarea - a.idTarea);
      setTareas(tareasOrdenadas);
      setMostrandoTareasCompletas(false);
      setMostrandoTareasPorFecha(false);
      setMostrandoTareasEstadosEspecificos(true);
    } else {
      setError(response.message);
    }
    setLoading(false);
  };

  const cargarTareasPorFecha = async () => {
    if (!fechaInicio || !fechaFin) {
      setError('Por favor, seleccione ambas fechas.');
      return;
    }

    setLoading(true);
    setError(null);
    const response = await getTareasPorFiltroFecha(fechaInicio, fechaFin);
    if (response.success) {
      console.log('Tareas por fecha recibidas:', response.data);
      const tareasOrdenadas = response.data.slice().sort((a, b) => b.idTarea - a.idTarea);
      setTareas(tareasOrdenadas);
      setMostrandoTareasCompletas(false);
      setMostrandoTareasPorFecha(true);
      setMostrandoTareasEstadosEspecificos(false);
    } else {
      setError(response.message);
    }
    setLoading(false);
  };

  const handleAsignarClick = (tarea) => {
    setSelectedTarea(tarea);
    setSelectedUsuario(tarea.usuarioResponsableId || '');
    setModalError('');
    setModalSuccess('');
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTarea(null);
    setSelectedUsuario('');
    setModalError('');
    setModalSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedUsuario) {
      setModalError('Seleccione un responsable');
      return;
    }
    setModalLoading(true);
    const response = await asignarResponsableTarea(selectedTarea.idTarea, parseInt(selectedUsuario));
    if (response.success) {
      setModalSuccess('Responsable asignado correctamente');
      setTareas(prev => prev.map(t => t.idTarea === selectedTarea.idTarea ? { ...t, usuarioResponsableNombre: usuarios.find(u => u.idUsuario === parseInt(selectedUsuario))?.nombres + ' ' + usuarios.find(u => u.idUsuario === parseInt(selectedUsuario))?.apellidos, usuarioResponsableId: parseInt(selectedUsuario) } : t));
      setTimeout(() => {
        handleCloseModal();
      }, 1500);
    } else {
      setModalError(response.message);
    }
    setModalLoading(false);
  };

  const handleAbrirEstadoModal = async (tarea) => {
    setTareaEstado(tarea);
    setSelectedEstado('');
    setEstadoError('');
    setShowEstadoModal(true);
    setEstadoLoading(true);
    try {
      const data = await getDetalleByParametroId(5);
      setEstados(data);
    } catch {
      setEstados([]);
    }
    setEstadoLoading(false);
  };

  const handleCerrarEstadoModal = () => {
    setShowEstadoModal(false);
    setTareaEstado(null);
    setSelectedEstado('');
    setEstadoError('');
  };

  const handleGuardarEstado = async (e) => {
    e.preventDefault();
    if (!selectedEstado) {
      setEstadoError('Seleccione un estado');
      return;
    }
    setEstadoLoading(true);
    const resp = await updateEstadoTarea(tareaEstado.idTarea, parseInt(selectedEstado));
    if (resp.success) {
      setTareas(prev => prev.map(t => t.idTarea === tareaEstado.idTarea ? { ...t, estadoId: parseInt(selectedEstado) } : t));
      handleCerrarEstadoModal();
    } else {
      setEstadoError(resp.message || 'Error al cambiar el estado');
    }
    setEstadoLoading(false);
  };

  const columns = [
    { key: 'idTarea', label: 'ID Tarea' },
    { key: 'observaciones', label: 'Observaciones' },
    { key: 'estado', label: 'Estado', formatter: (estado) => estado || '' },
    { key: 'prioridadNombre', label: 'Prioridad' },
    { 
      key: 'fechaCreacion',
      label: 'Fecha Creación',
      formatter: (date) => formatearBogota(date)
    },
    { key: 'usuarioCreadorNombre', label: 'Usuario Creador' },
    { key: 'cargoUsuarioCliente', label: 'Cargo' },
    { key: 'areaNombre', label: 'Área' },
    { key: 'sedeNombre', label: 'Sede' },
    { key: 'servicioNombre', label: 'Servicio' },
    { key: 'usuarioResponsableNombre', label: 'Responsable', formatter: (nombre) => nombre || <span style={{ color: '#888' }}>(Sin responsable)</span> },
    { key: 'rutaDocumento', label: 'Ruta Documento', formatter: (url) => url ? (<a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'underline' }}>Ruta Documento</a>) : '' },
    { key: 'urlEvidencia', label: 'Evidencia', formatter: (url) => url ? (<a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'underline' }}>Ir a evidencia</a>) : '' },
    {
      key: 'acciones',
      label: 'Acciones',
      formatter: (value, row) => {
        if (!row) return null;
        return (
          <>
            <button
              className="view-btn"
              style={{ padding: '4px 12px', fontSize: '14px', marginRight: 6 }}
              onClick={() => { setDetalleTarea(row); setShowVerModal(true); }}
            >
              Ver
            </button>
            <ComentarioButton tareaId={row.idTarea} />
            <button
              className="cambiar-estado-btn"
              style={{ padding: '4px 12px', fontSize: '14px', marginLeft: 6 }}
              onClick={() => handleAbrirEstadoModal(row)}
            >
              Cambiar Estado
            </button>
            <button
              className="cambiar-responsable-btn"
              style={{ padding: '4px 12px', fontSize: '14px', marginLeft: 6 }}
              onClick={() => handleAsignarClick(row)}
            >
              {row.usuarioResponsableNombre ? 'Cambiar Responsable' : 'Asignar Responsable'}
            </button>
            <PrioridadButton tareaId={row.idTarea} />
            <CambiarAreaButton tareaId={row.idTarea} />
            <CambiarCategoriaButton tareaId={row.idTarea} areaId={row.areaId || userArea} />
            <EvidenciaButton tareaId={row.idTarea} />
          </>
        );
      }
    }
  ];

  const content = (
    <div>
      <h2>Ver todas las tareas del área {nombreArea || `Área ${userArea || ''}`}</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <button
          onClick={cargarTareasActivas}
          disabled={loading}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            backgroundColor: (!mostrandoTareasCompletas && !mostrandoTareasPorFecha && !mostrandoTareasEstadosEspecificos) ? '#007bff' : '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          Ver Tareas Activas
        </button>
        <button
          onClick={cargarTareasCompletas}
          disabled={loading}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            backgroundColor: (mostrandoTareasCompletas && !mostrandoTareasPorFecha && !mostrandoTareasEstadosEspecificos) ? '#007bff' : '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          Ver Tareas Completas
        </button>
        <button
          onClick={cargarTareasEstadosEspecificos}
          disabled={loading}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            backgroundColor: mostrandoTareasEstadosEspecificos ? '#007bff' : '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          Ver Estados Específicos
        </button>
      </div>

      <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px', backgroundColor: '#f9f9f9' }}>
        <h4 style={{ marginTop: '0', marginBottom: '15px' }}>Filtrar por Fecha</h4>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
          <div>
            <label htmlFor="fechaInicio" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
              Fecha Inicio:
            </label>
            <input
              type="date"
              id="fechaInicio"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
              style={{
                padding: '8px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                fontSize: '14px'
              }}
            />
          </div>
          <div>
            <label htmlFor="fechaFin" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
              Fecha Fin:
            </label>
            <input
              type="date"
              id="fechaFin"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
              style={{
                padding: '8px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                fontSize: '14px'
              }}
            />
          </div>
          <div style={{ alignSelf: 'end' }}>
            <button
              onClick={cargarTareasPorFecha}
              disabled={loading || !fechaInicio || !fechaFin}
              style={{
                padding: '10px 20px',
                backgroundColor: mostrandoTareasPorFecha ? '#007bff' : '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: (loading || !fechaInicio || !fechaFin) ? 'not-allowed' : 'pointer',
                opacity: (loading || !fechaInicio || !fechaFin) ? 0.6 : 1
              }}
            >
              Buscar por Fecha
            </button>
          </div>
        </div>
      </div>

      {loading && <p>Cargando tareas...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && !error && tareas.length > 0 && (
        <ReusableTable 
          data={tareas} 
          columns={columns}
          keyField="idTarea"
        />
      )}
      {!loading && !error && tareas.length === 0 && (
        <p>
          {mostrandoTareasCompletas 
            ? 'No hay tareas completas disponibles' 
            : mostrandoTareasPorFecha
            ? 'No hay tareas disponibles en el rango de fechas seleccionado'
            : mostrandoTareasEstadosEspecificos
            ? 'No hay tareas con estados específicos disponibles (Rechazadas, Sin acción, Derivada a proveedor)'
            : 'No hay tareas activas disponibles'
          }
        </p>
      )}
      {/* Modal de Asignación/Cambio de Responsable */}
      {showVerModal && (
        <Modal
          title={`Detalle de Tarea #${detalleTarea?.idTarea || ''}`}
          onClose={() => { setShowVerModal(false); setDetalleTarea(null); }}
          actions={
            <button 
              onClick={() => { setShowVerModal(false); setDetalleTarea(null); }}
              style={{
                padding: '8px 16px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Cerrar
            </button>
          }
        >
          {detalleTarea && (
            <div className="table-container">
              <table className="detail-table">
                <tbody>
                  <tr><th>Estado</th><td>{detalleTarea.estado}</td></tr>
                  <tr><th>Fecha Creación</th><td>{formatearBogota(detalleTarea.fechaCreacion)}</td></tr>
                  <tr><th>Fecha Edición</th><td>{detalleTarea.fechaEdicion ? formatearBogota(detalleTarea.fechaEdicion) : 'N/A'}</td></tr>
                  <tr><th>Área</th><td>{detalleTarea.areaNombre}</td></tr>
                  <tr><th>Sede</th><td>{detalleTarea.sedeNombre}</td></tr>
                  <tr><th>Servicio</th><td>{detalleTarea.servicioNombre}</td></tr>
                  <tr><th>Prioridad</th><td>{detalleTarea.prioridadNombre}</td></tr>
                  <tr><th>Categoría</th><td>{detalleTarea.categoriaNombre}</td></tr>
                  <tr><th>Subcategoría</th><td>{detalleTarea.subcategoriaNombre}</td></tr>
                  <tr><th>Observaciones</th><td>{detalleTarea.observaciones}</td></tr>
                  <tr><th>Usuario Creador</th><td>{detalleTarea.usuarioCreadorNombre}</td></tr>
                  <tr><th>Responsable</th><td>{detalleTarea.usuarioResponsableNombre || '(Sin responsable)'}</td></tr>
                  <tr><th>Cargo Usuario Cliente</th><td>{detalleTarea.cargoUsuarioCliente}</td></tr>
                  <tr><th>Calificación</th><td>{detalleTarea.calificacion ?? 'N/A'}</td></tr>
                  <tr><th>Comentario Calificación</th><td>{detalleTarea.comentarioCalificacion ?? 'N/A'}</td></tr>
                  <tr>
                    <th>Documento</th>
                    <td>{detalleTarea.rutaDocumento ? <a href={detalleTarea.rutaDocumento} target="_blank" rel="noopener noreferrer">Abrir</a> : 'Sin documento'}</td>
                  </tr>
                  <tr>
                    <th>Evidencia</th>
                    <td>{detalleTarea.urlEvidencia ? <a href={detalleTarea.urlEvidencia} target="_blank" rel="noopener noreferrer">Abrir</a> : 'Sin evidencia'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </Modal>
      )}
      {/* Modal de Asignación/Cambio de Responsable */}
      {showModal && (
        <Modal
          title={selectedTarea?.usuarioResponsableNombre ? 'Cambiar Responsable' : 'Asignar Responsable'}
          onClose={handleCloseModal}
          actions={
            <button 
              onClick={handleCloseModal}
              style={{
                padding: '8px 16px',
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Cancelar
            </button>
          }
        >
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <h3>Tarea: {selectedTarea?.observaciones}</h3>
              <p><strong>ID:</strong> {selectedTarea?.idTarea}</p>
              <p><strong>Área:</strong> {selectedTarea?.areaNombre}</p>
            </div>
            {modalError && <div style={{ color: 'red', marginBottom: '10px' }}>{modalError}</div>}
            {modalSuccess && <div style={{ color: 'green', marginBottom: '10px' }}>{modalSuccess}</div>}
            <div style={{ marginBottom: '15px' }}>
              <label htmlFor="responsable" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Seleccionar Responsable:
              </label>
              <select
                id="responsable"
                value={selectedUsuario}
                onChange={(e) => setSelectedUsuario(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  fontSize: '14px'
                }}
              >
                <option value="">Seleccione un responsable</option>
                {usuarios.map(usuario => (
                  <option key={usuario.idUsuario} value={usuario.idUsuario}>
                    {usuario.nombres} {usuario.apellidos}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ textAlign: 'right' }}>
              <button
                type="submit"
                className="edit-btn"
                disabled={modalLoading}
                style={{ fontSize: '14px' }}
              >
                {modalLoading ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </form>
        </Modal>
      )}
      {/* Modal de Cambio de Estado */}
      {showEstadoModal && (
        <Modal
          title="Cambiar Estado de la Tarea"
          onClose={handleCerrarEstadoModal}
          actions={
            <button
              onClick={handleCerrarEstadoModal}
              style={{
                padding: '8px 16px',
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Cancelar
            </button>
          }
        >
          <form onSubmit={handleGuardarEstado}>
            <div style={{ marginBottom: '20px' }}>
              <h3>Tarea: {tareaEstado?.observaciones}</h3>
              <p><strong>ID:</strong> {tareaEstado?.idTarea}</p>
              <p><strong>Estado actual:</strong> {tareaEstado?.estadoId}</p>
            </div>
            {estadoError && <div style={{ color: 'red', marginBottom: '10px' }}>{estadoError}</div>}
            <div style={{ marginBottom: '15px' }}>
              <label htmlFor="estado" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Seleccionar nuevo estado:
              </label>
              <select
                id="estado"
                value={selectedEstado}
                onChange={e => setSelectedEstado(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  fontSize: '14px'
                }}
                disabled={estadoLoading}
              >
                <option value="">Seleccione un estado</option>
                {estados.map(opt => (
                  <option key={opt.id_detaparametro} value={opt.id_detaparametro}>{opt.nombre}</option>
                ))}
              </select>
            </div>
            <div style={{ textAlign: 'right' }}>
              <button
                type="submit"
                className="cambiar-estado-btn"
                disabled={estadoLoading}
                style={{ fontSize: '14px' }}
              >
                {estadoLoading ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );

  // Si es una ruta de soporte, usar SoporteLayout
  if (isSoporteRoute) {
    return <SoporteLayout>{content}</SoporteLayout>;
  }

  // Si no es ruta de soporte, usar el layout normal (para admin)
  return content;
};

export default withAuth(VerTareasAreaPage); 